import type { DummyFoods } from './dummyFoods'

export const pea: DummyFoods = {
  Pea: {
    Green: ['Green peas'],
    Split: ['Split peas'],
    'Sugar snap': ['Sugar snap peas'],
  },
}
